import { useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import "./Landing.css"

// ── Iconos SVG inline (sin dependencias) ─────────
const IconIG  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
const IconWA  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>


const beneficios = [
  {
    icono: "🧭",
    titulo: "Hablás con Sergio, no con un bot",
    texto: "Sin formularios ni call centers. Desde el primer mensaje hasta que volvés de tu viaje, tenés una persona real del otro lado.",
  },
  {
    icono: "💸",
    titulo: "El precio que acordamos es el que pagás",
    texto: "Sin letra chica, sin impuestos que aparecen al final. Cotización clara desde el primer momento.",
  },
  {
    icono: "🏝️",
    titulo: "Destinos que no encontrás en Despegar",
    texto: "Combinaciones de lugares que los buscadores automáticos no arman. Río + Búzios, Maceió + Maragogi — rutas pensadas por alguien que las conoce.",
  },
  {
    icono: "🛡️",
    titulo: "Estamos cuando más lo necesitás",
    texto: "Si algo pasa durante el viaje, no estás solo. Contacto directo en todo momento, no solo en la venta.",
  },
]

function VideoLazy({ videoId }) {
  const [activo, setActivo] = useState(false)
  return (
    <div className="video-wrapper" style={{ cursor: activo ? "default" : "pointer", position: "relative" }} onClick={() => setActivo(true)}>
      {activo ? (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="Sergio - Low Travel"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ width:"100%", height:"100%", display:"block" }}
        />
      ) : (
        <>
          <img
            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            alt="Ver video de Sergio"
            style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", borderRadius:"16px" }}
            loading="lazy"
          />
          <div style={{
            position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center",
            background:"rgba(0,0,0,0.25)", borderRadius:"16px"
          }}>
            <div style={{
              width:"64px", height:"64px", background:"rgba(255,0,0,0.9)", borderRadius:"50%",
              display:"flex", alignItems:"center", justifyContent:"center",
              boxShadow:"0 4px 20px rgba(0,0,0,0.4)", transition:"transform 0.2s"
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </div>
        </>
      )}
    </div>
  )
}


export default function Landing() {
  const { user } = useAuth()

  return (
    <div className="landing">

      {/* ── HERO ─────────────────────────────────── */}
      <section className="hero">
        <div className="hero__bg" />
        <div className="container">
          <div className="hero__inner">
            <div className="hero__badge">✈️ Viajemos Juntos!!</div>
            <h1 className="hero__titulo">
              Tu próximo destino,<br />
              <span>gestionado por Sergio.</span>
            </h1>
            <p className="hero__subtitulo">
              Tu viaje está en buenas manos. Priorizamos calidad, precio y atención
              directa para diseñar una propuesta a tu medida.
            </p>
            <div className="hero__ctas">
              <Link
                to="/consulta"
                className="hero__btn hero__btn--primary"
              >
                Hablemos de tu viaje
              </Link>
              <Link
                to="/propuestas"
                className="hero__btn hero__btn--outline"
              >
                Ver propuestas
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── COMUNIDAD BANNER ─────────────────────── */}
      <div className="comunidad-bar">
        <div className="container">
          <div className="comunidad-bar__inner">
            <span className="comunidad-bar__icono">💬</span>
            <div>
              <div className="comunidad-bar__titulo">Comunidad Low Travel</div>
              <div className="comunidad-bar__texto">Ofertas exclusivas, destinos nuevos y experiencias de otros viajeros</div>
            </div>
            <a
              href="https://chat.whatsapp.com/BM4kol2GxzFDe9e5rWSNhz"
              target="_blank"
              rel="noreferrer"
              className="comunidad-bar__btn"
            >
              Unirme al grupo
            </a>
          </div>
        </div>
      </div>

      {/* ── VIDEO DE SERGIO ───────────────────────── */}
      <section className="seccion">
        <div className="container">
          <div className="video-section">
            <div className="video-section__texto">
              <div className="seccion__badge">Conocé a tu asesor</div>
              <h2 className="seccion__titulo" style={{ textAlign: "left", marginBottom: "16px" }}>
                Hola, soy Sergio.
              </h2>
              <p className="video-section__descripcion">
                Soy asesor de viajes independiente, apasionado por conectar a las personas con
                los destinos que sueñan. Trabajo de forma personalizada — cada viaje que organizo
                lo trato como si fuera el mío propio.
              </p>
              <p className="video-section__descripcion">
                En Low Travel no hay intermediarios ni call centers. Me escribís a mí, yo te
                respondo, y juntos armamos algo que valga la pena recordar.
              </p>
              <a
                href="https://wa.me/5491125603574?text=Hola Sergio! Quiero asesoramiento para mi proximo viaje"
                target="_blank"
                rel="noreferrer"
                className="sergio-btn"
              >
                <IconWA /> Escribir a Sergio
              </a>
              <Link
                to="/propuestas"
                className="sergio-btn sergio-btn--outline"
              >
                Ver propuestas →
              </Link>
            </div>
            <div className="video-section__video">
              <VideoLazy videoId="AIgSOCf-39E" />
            </div>
          </div>
        </div>
      </section>

      {/* ── POR QUÉ ELEGIRNOS ─────────────────────── */}
      <section className="seccion seccion--gris">
        <div className="container">
          <div className="seccion__header">
            <div className="seccion__badge">Por qué Low Travel</div>
            <h2 className="seccion__titulo">Lo que nos diferencia</h2>
            <p className="seccion__subtitulo">
              No somos una plataforma. Somos una agencia con nombre y apellido.
            </p>
          </div>
          <div className="beneficios-grid">
            {beneficios.map(b => (
              <div className="beneficio-item" key={b.titulo}>
                <span className="beneficio-item__icono">{b.icono}</span>
                <div className="beneficio-item__titulo">{b.titulo}</div>
                <div className="beneficio-item__texto">{b.texto}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CALENDLY ─────────────────────────────── */}
      <section className="seccion seccion--gris">
        <div className="container">
          <div className="calendly-section">
            <div className="calendly-section__texto">
              <div className="seccion__badge">📅 Sin vueltas</div>
              <h2 className="seccion__titulo" style={{ textAlign: "left", marginBottom: "12px" }}>
                Agendá una llamada<br />con Sergio
              </h2>
              <p className="calendly-section__desc">
                10 minutos, sin compromiso. Contás cómo te gustaría viajar
                y Sergio te arma una propuesta a medida.
              </p>
              <ul className="calendly-section__lista">
                <li>✅ Elegís el día y horario que más te conviene</li>
                <li>✅ Asesoramiento 100% personalizado</li>
                <li>✅ Sin costo, sin obligación</li>
              </ul>
              <a
                href="https://calendly.com/chechotrade/30min"
                target="_blank"
                rel="noreferrer"
                className="calendly-section__btn"
              >
                📅 Reservar mi turno
              </a>
            </div>
            <div className="calendly-section__visual">
              <div className="calendly-card">
                <div className="calendly-card__header">
                  <div className="calendly-card__avatar">S</div>
                  <div>
                    <div className="calendly-card__nombre">Sergio — Low Travel</div>
                    <div className="calendly-card__tipo">Asesoramiento de viaje</div>
                  </div>
                </div>
                <div className="calendly-card__duracion">
                  <span>🕐</span> 30 minutos · Videollamada o WhatsApp
                </div>
                <div className="calendly-card__slots">
                  <div className="calendly-card__slots-titulo">Próximos turnos disponibles</div>
                  {["Lun 9:00", "Mar 11:00", "Jue 15:00", "Vie 10:00"].map(s => (
                    <div key={s} className="calendly-card__slot">{s}</div>
                  ))}
                </div>
                <a
                  href="https://calendly.com/chechotrade/30min"
                  target="_blank"
                  rel="noreferrer"
                  className="calendly-card__cta"
                >
                  Ver disponibilidad →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ────────────────────────────── */}
      <section className="cta-final">
        <div className="container">
          <h2 className="cta-final__titulo">
            Tu próximo viaje te está esperando
          </h2>
          <p className="cta-final__subtitulo">
            Registrate gratis y accedé a tu panel personal con todos tus viajes,
            documentos y puntos de fidelidad.
          </p>
          <div className="cta-final__btns">
            {user ? (
              <Link to="/dashboard" className="hero__btn hero__btn--primary">
                Ver mi panel
              </Link>
            ) : (
              <Link
                to="/register"
                className="hero__btn hero__btn--primary"
              >
                Crear mi cuenta gratis
              </Link>
            )}
            <a
              href="https://wa.me/5491125603574"
              target="_blank"
              rel="noreferrer"
              className="hero__btn hero__btn--outline"
            >
              Hablar con Sergio
            </a>
          </div>
        </div>
      </section>

    </div>
  )
}